import { useState, useEffect, useMemo } from 'react';

interface Availability {
  userManagement: boolean;
  transcriptor: boolean;
  inteligenciaDocumental: boolean;
  busquedaGenAi: boolean;
  analisisDePrecedente: boolean;
  promptGenAi: boolean;
  perfil: boolean;
  ajustes: boolean;
  salir: boolean;
  soporte: boolean;
  faq: boolean;
}

const useAvailability = (userProfile: { role: string } | null, userPermissions: string[]): Availability => {
  const initialAvailability: Availability = useMemo(() => ({
    transcriptor: userPermissions.includes('Transcriptor'),
    userManagement: userProfile?.role === 'admin',
    inteligenciaDocumental: userPermissions.includes('inteligenciaDocumental'),
    busquedaGenAi: userPermissions.includes('busquedaGenAi'),
    analisisDePrecedente: userPermissions.includes('Precedents'),
    promptGenAi: userPermissions.includes('promptGenAi'),
    perfil: true,
    ajustes: userProfile?.role === 'admin',
    salir: true,
    soporte: true,
    faq: true,
  }), [userProfile, userPermissions]);

  return initialAvailability;
};

export default useAvailability;